import { render, staticRenderFns } from "./OpDashboardView.vue?vue&type=template&id=63ff7007&"
import script from "./OpDashboardView.vue?vue&type=script&lang=js&"
export * from "./OpDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./OpDashboardView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports